export const isFloat = (n: number) => Number(n) === n && n % 1 !== 0;

export const getAmount = (amount: number) => String(isFloat(amount) ? amount.toFixed(2) : amount);

export const getTabs = () => ['invoices', 'products'].map(
  name => ({
    name,
    to: `/billing/${name}`,
  }),
);

export const fakeInvoices = [
  {
    id: 9752,
    product_id: null,
    product_plan_id: 40,
    product_plan_name: 'Muscle Subscription',
    stripe_id: 'in_1ImfO4EGZJFcdzeSaQAbVA0Z',
    connected_account_id: null,
    account_name: 'Training App (by GymCloud)',
    account_country: 'US',
    billing_reason: 'manual',
    collection_method: 'send_invoice',
    charge: null,
    currency: 'usd',
    customer: 'cus_Hoetpw9EsYzwvW',
    customer_email: 'gymcloud@strongfirst.com',
    customer_name: 'Julie Smith',
    description: 'Invoice',
    hosted_invoice_url:
      'https://invoice.stripe.com/i/acct_17vtu9EGZJFcdzeS/invst_JPUM1a6NopKOZy5PJqKKBIN9JyCfv7B',
    invoice_pdf:
      'https://pay.stripe.com/invoice/acct_17vtu9EGZJFcdzeS/invst_JPUM1a6NopKOZy5PJqKKBIN9JyCfv7B/pdf',
    livemode: false,
    paid: false,
    attempt_count: 0,
    status: 'void',
    subscription: null,
    lines:
      '[{"id":"ii_1ImfO3EGZJFcdzeSSYXoRDSt","object":"line_item","amount":20000,"currency":"usd","description":"Invoice Item","discount_amounts":[],"discountable":true,"discounts":[],"invoice_item":"ii_1ImfO3EGZJFcdzeSSYXoRDSt","livemode":false,"metadata":{},"period":{"end":1619962267,"start":1619962267},"plan":null,"price":{"id":"price_1ImfO3EGZJFcdzeS6VVL5rgH","object":"price","active":false,"billing_scheme":"per_unit","created":1619962267,"currency":"usd","livemode":false,"lookup_key":null,"metadata":{},"nickname":null,"product":"prod_JPUMAIvLbMeHyt","recurring":null,"tiers_mode":null,"transform_quantity":null,"type":"one_time","unit_amount":20000,"unit_amount_decimal":"20000"},"proration":false,"quantity":1,"subscription":null,"tax_amounts":[],"tax_rates":[],"type":"invoiceitem","unique_id":"il_1ImfO3EGZJFcdzeSjAJLCGCV"}]',
    amount_due: 20000.0,
    amount_paid: 0.0,
    amount_remaining: 20000.0,
    application_fee: 6427.0,
    subtotal: 20000.0,
    tax: 0.0,
    total: 6999,
    due_date: '2021-06-01T13:31:08.000Z',
    period_start: '2021-05-02T13:31:08.000Z',
    period_end: '2021-05-02T13:31:08.000Z',
    created: '2021-03-03T02:52:14.000Z',
    paid_at: '2021-03-04T02:52:14.000Z',
    next_payment_attempt: null,
  },
  {
    id: 9750,
    product_id: null,
    product_plan_id: 40,
    product_plan_name: 'Muscle Subscription',
    stripe_id: 'in_1ImfJtEGZJFcdzeSBE3Sxs5g',
    connected_account_id: null,
    account_name: 'Training App (by GymCloud)',
    account_country: 'US',
    billing_reason: 'manual',
    collection_method: 'send_invoice',
    charge: 'ch_1ImfKyEGZJFcdzeSnlpm1bGy',
    currency: 'usd',
    customer: 'cus_Hoetpw9EsYzwvW',
    customer_email: 'gymcloud@strongfirst.com',
    customer_name: 'William Johnson',
    description: 'Invoice',
    hosted_invoice_url:
      'https://invoice.stripe.com/i/acct_17vtu9EGZJFcdzeS/invst_JPUILhpd7Ms5L56Ql8CABRsAAhVRIbu',
    invoice_pdf:
      'https://pay.stripe.com/invoice/acct_17vtu9EGZJFcdzeS/invst_JPUILhpd7Ms5L56Ql8CABRsAAhVRIbu/pdf',
    livemode: false,
    paid: true,
    attempt_count: 1,
    status: 'paid',
    subscription: null,
    lines:
      '[{"id":"ii_1ImfJsEGZJFcdzeSyKpjah1V","object":"line_item","amount":20000,"currency":"usd","description":"Invoice Item","discount_amounts":[],"discountable":true,"discounts":[],"invoice_item":"ii_1ImfJsEGZJFcdzeSyKpjah1V","livemode":false,"metadata":{},"period":{"end":1619962008,"start":1619962008},"plan":null,"price":{"id":"price_1ImfJsEGZJFcdzeSayiMoODy","object":"price","active":false,"billing_scheme":"per_unit","created":1619962008,"currency":"usd","livemode":false,"lookup_key":null,"metadata":{},"nickname":null,"product":"prod_JPUIVpcSC17R2I","recurring":null,"tiers_mode":null,"transform_quantity":null,"type":"one_time","unit_amount":20000,"unit_amount_decimal":"20000"},"proration":false,"quantity":1,"subscription":null,"tax_amounts":[],"tax_rates":[],"type":"invoiceitem","unique_id":"il_1ImfJsEGZJFcdzeSMPVAXJbc"}]',
    amount_due: 20000.0,
    amount_paid: 20000.0,
    amount_remaining: 0.0,
    application_fee: 6427.0,
    subtotal: 20000.0,
    tax: 0.0,
    total: 10000.0,
    due_date: '2021-06-01T13:26:49.000Z',
    period_start: '2021-05-02T13:26:49.000Z',
    period_end: '2021-05-02T13:26:49.000Z',
    created: '2021-02-28T13:26:03.000Z',
    paid_at: '2021-03-01T02:52:14.000Z',
    next_payment_attempt: null,
  },
  {
    id: 9753,
    product_id: null,
    product_plan_id: 40,
    product_plan_name: 'Muscle Subscription',
    stripe_id: 'in_1ImfJ9EGZJFcdzeSlfYfHwLk',
    connected_account_id: null,
    account_name: 'Training App (by GymCloud)',
    account_country: 'US',
    billing_reason: 'manual',
    collection_method: 'send_invoice',
    charge: null,
    currency: 'usd',
    customer: 'cus_Hoetpw9EsYzwvW',
    customer_email: 'gymcloud@strongfirst.com',
    customer_name: 'Josh Smith',
    description: 'Invoice',
    hosted_invoice_url:
      'https://invoice.stripe.com/i/acct_17vtu9EGZJFcdzeS/invst_JPUH5vAZ9XYd0R2kDuhtK1WbXQwVOZk',
    invoice_pdf:
      'https://pay.stripe.com/invoice/acct_17vtu9EGZJFcdzeS/invst_JPUH5vAZ9XYd0R2kDuhtK1WbXQwVOZk/pdf',
    livemode: false,
    paid: false,
    attempt_count: 0,
    status: 'paid',
    subscription: null,
    lines:
      '[{"id":"ii_1ImfJ8EGZJFcdzeSVMb9pZ0L","object":"line_item","amount":20000,"currency":"usd","description":"Invoice Item","discount_amounts":[],"discountable":true,"discounts":[],"invoice_item":"ii_1ImfJ8EGZJFcdzeSVMb9pZ0L","livemode":false,"metadata":{},"period":{"end":1619961962,"start":1619961962},"plan":null,"price":{"id":"price_1ImfJ8EGZJFcdzeSL0rN8Bb3","object":"price","active":false,"billing_scheme":"per_unit","created":1619961962,"currency":"usd","livemode":false,"lookup_key":null,"metadata":{},"nickname":null,"product":"prod_JPUHh2g8S3HjSL","recurring":null,"tiers_mode":null,"transform_quantity":null,"type":"one_time","unit_amount":20000,"unit_amount_decimal":"20000"},"proration":false,"quantity":1,"subscription":null,"tax_amounts":[],"tax_rates":[],"type":"invoiceitem","unique_id":"il_1ImfJ8EGZJFcdzeSHRCE7fLF"}]',
    amount_due: 20000.0,
    amount_paid: 0.0,
    amount_remaining: 20000.0,
    application_fee: 6427.0,
    subtotal: 20000.0,
    tax: 0.0,
    total: 1499,
    due_date: '2021-06-01T13:26:03.000Z',
    period_start: '2021-05-02T13:26:03.000Z',
    period_end: '2021-05-02T13:26:03.000Z',
    created: '2021-02-28T13:26:03.000Z',
    paid_at: '2021-03-01T02:52:14.000Z',
    next_payment_attempt: null,
  },
];
